import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addCandidateToPipeline,
  addPipeline,
  deletePipeline,
  getPipeline,
  getPipelineData,
  importCandidateToPipeline,
  updatePipeline,
} from "api/pipeline.api";

import { notificationController } from "controllers/notificationController";

export interface RolesSlice {
  pipeline_data: any;
  pipeline_loading_status: number;
  pipeline_details: any;
}

const initialState: RolesSlice = {
  pipeline_data: null,
  pipeline_loading_status: 0,
  pipeline_details: null,
};

export const doGetPipeLineList = createAsyncThunk(
  "pipeline/doGetPipeLineList",
  async () =>
    getPipelineData().then((res: any) => {
      return res;
    })
);

export const doDeletePipeline = createAsyncThunk(
  "pipeline/doDeletePipeline",
  async (roleId: any, { dispatch }) => {
    deletePipeline(roleId).then(
      (res) => {
        dispatch(doGetPipeLineList());
        return res;
      },
      (error) => {
        notificationController.error({
          message: error.toString(),
        });
      }
    );
  }
);
export const doAddPipeline = createAsyncThunk(
  "pipeline/doAddPipeline",
  async (pipelinePayload: any, { dispatch }) =>
    addPipeline(pipelinePayload).then((res) => {
      dispatch(doGetPipeLineList());
      return res;
    })
);

export const doUpdatePipeline = createAsyncThunk(
  "pipeline/doUpdatePipeline",
  async (pipelinePayload: any, { dispatch }) =>
    updatePipeline(pipelinePayload.id, pipelinePayload).then((res) => {
      dispatch(doGetPipeLineList());
      return res;
    })
);

export const doImportCandidateToPipeline = createAsyncThunk(
  "pipeline/doImportCandidateToPipeline",
  async (pipelinePayload: any, { dispatch }) =>
    importCandidateToPipeline(pipelinePayload).then((res) => {
      dispatch(doGetPipeLineList());

      //dispatch(doGetPipelineDetails(pipelinePayload.pipelineId));
      return res;
    })
);

export const doGetPipelineDetails = createAsyncThunk(
  "pipeline/doGetPipelineDetails",
  async (id: any, { dispatch }) =>
    getPipeline(id).then((res) => {
      return res;
    })
);
export const doAddCandidateToPipeline = createAsyncThunk(
  "pipeline/doAddCandidateToPipeline",
  async (payload: any, { dispatch }) =>
    addCandidateToPipeline(payload).then((res: any) => {
      return res;
    })
);

const pipelineSlice = createSlice({
  name: "pipeline",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetPipeLineList.pending, (state, action) => {
      state.pipeline_loading_status = 1;
    });
    builder.addCase(doGetPipeLineList.fulfilled, (state, action) => {
      state.pipeline_data = action.payload;
      state.pipeline_loading_status = 2;
    });
    builder.addCase(doGetPipelineDetails.fulfilled, (state, action) => {
      state.pipeline_details = action.payload;
      state.pipeline_loading_status = 0;
    });
  },
});

export default pipelineSlice.reducer;
